import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@shared/features/auth/context/AuthContext';
import { ErrorBoundary } from '@shared/components/ErrorBoundary';
import { router } from '@shared/app/router';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;